/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetPayouts200,
  GetPayoutsParams,
  Payout,
  CreatePayoutBody,
  ValidatePayout200,
  PayoutValidationError,
  ValidatePayoutBody,
  PayoutQuote,
  GetPayoutQuoteBody
} from './schema'



/**
 * Retrieve a list of payouts
 * @summary Get Payouts
 */
export const getPayouts = (
    params?: GetPayoutsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetPayouts200>> => {
    return axios.get(
      `/payouts`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetPayoutsQueryKey = (params?: GetPayoutsParams,) => [`/payouts`, ...(params ? [params]: [])];

    
export type GetPayoutsQueryResult = NonNullable<Awaited<ReturnType<typeof getPayouts>>>
export type GetPayoutsQueryError = AxiosError<unknown>

export const useGetPayouts = <TData = Awaited<ReturnType<typeof getPayouts>>, TError = AxiosError<unknown>>(
 params?: GetPayoutsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPayouts>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPayoutsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayouts>>> = ({ signal }) => getPayouts(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPayouts>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Create a payout to an external destination
 * @summary Create Payout
 */
export const createPayout = (
    createPayoutBody: CreatePayoutBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Payout>> => {
    return axios.post(
      `/payouts`,
      createPayoutBody,options
    );
  }



    export type CreatePayoutMutationResult = NonNullable<Awaited<ReturnType<typeof createPayout>>>
    export type CreatePayoutMutationBody = CreatePayoutBody
    export type CreatePayoutMutationError = AxiosError<unknown>

    export const useCreatePayout = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPayout>>, TError,{data: CreatePayoutBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPayout>>, {data: CreatePayoutBody}> = (props) => {
          const {data} = props ?? {};

          return  createPayout(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof createPayout>>, TError, {data: CreatePayoutBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Validate payout parameters and destination before processing a payout request.
This endpoint is currently only supported for the UNIONPAY and ALIPAY method, and is intended to ensure that the payout request meets the necessary minimum criteria for successful processing. Note that even a pre-validated payout may still fail to be processed if the destination is invalid for other reasons not checked by this endpoint.
 * @summary Validate Payout Parameters
 */
export const validatePayout = (
    validatePayoutBody: ValidatePayoutBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ValidatePayout200>> => {
    return axios.post(
      `/payouts/validate`,
      validatePayoutBody,options
    );
  }



    export type ValidatePayoutMutationResult = NonNullable<Awaited<ReturnType<typeof validatePayout>>>
    export type ValidatePayoutMutationBody = ValidatePayoutBody
    export type ValidatePayoutMutationError = AxiosError<PayoutValidationError>

    export const useValidatePayout = <TError = AxiosError<PayoutValidationError>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validatePayout>>, TError,{data: ValidatePayoutBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof validatePayout>>, {data: ValidatePayoutBody}> = (props) => {
          const {data} = props ?? {};

          return  validatePayout(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof validatePayout>>, TError, {data: ValidatePayoutBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * @summary Get Payout Quotation
 */
export const getPayoutQuote = (
    getPayoutQuoteBody: GetPayoutQuoteBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PayoutQuote>> => {
    return axios.post(
      `/payouts/quote`,
      getPayoutQuoteBody,options
    );
  }



    export type GetPayoutQuoteMutationResult = NonNullable<Awaited<ReturnType<typeof getPayoutQuote>>>
    export type GetPayoutQuoteMutationBody = GetPayoutQuoteBody
    export type GetPayoutQuoteMutationError = AxiosError<unknown>

    export const useGetPayoutQuote = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPayoutQuote>>, TError,{data: GetPayoutQuoteBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getPayoutQuote>>, {data: GetPayoutQuoteBody}> = (props) => {
          const {data} = props ?? {};

          return  getPayoutQuote(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof getPayoutQuote>>, TError, {data: GetPayoutQuoteBody}, TContext>(mutationFn, mutationOptions)
    }
    